'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Styles

// Types

// Mixins


require('../../../src/stylus/components/_dividers.styl');

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _themeable = require('../../mixins/themeable');

var _themeable2 = _interopRequireDefault(_themeable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _vue2.default.extend({
    name: 'v-divider',
    functional: true,
    props: _extends({}, _themeable2.default.options.props, {
        inset: Boolean,
        vertical: Boolean
    }),
    render: function render(h, _ref) {
        var props = _ref.props,
            data = _ref.data;

        data.staticClass = ('v-divider ' + (data.staticClass || '')).trim();
        if (props.inset) data.staticClass += ' v-divider--inset';
        if (props.vertical) data.staticClass += ' v-divider--vertical';
        if (props.light) data.staticClass += ' theme--light';
        if (props.dark) data.staticClass += ' theme--dark';
        return h('hr', data);
    }
});
//# sourceMappingURL=VDivider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/components/VDivider/VDivider.js
// module id = MFw7
// module chunks = 3 4 5 6 7 8 9